import { render, staticRenderFns } from "./NLPConfig.vue?vue&type=template&id=a5ac1db6&scoped=true&"
import script from "./NLPConfig.vue?vue&type=script&lang=js&"
export * from "./NLPConfig.vue?vue&type=script&lang=js&"
import style0 from "./NLPConfig.vue?vue&type=style&index=0&id=a5ac1db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac1db6",
  null
  
)

export default component.exports